import { useState, useEffect } from 'react';
import { InputTextCustom, Combobox, Modal, EInputTypes, WindowLoader } from 'medere-ui-framework';
import GeneralRecipeViewCard from '../../Components/GeneralRecipeViewCard';
import './MedicationStep.scss';
import CustomCheckBox from '../../../../components/CustomCheckBox/CustomCheckBox';
import { Button } from 'primereact/button';
import { Medicine, MedicinalProductsAndSubstancesDTO, MedicinalProductPresentationDTO, defaultMedicine, PatientRecordDTO, SaleCondition, HealthPatientCoverage } from '../../../../interface/interface';
import { getMedicines, getPresentations, getPreviousMedications } from '../../../../servicesHooks/DigitalRP/useDigitalRPService';
import CollapsibleCard from '../../../../components/Collapsible/CollapsibleCard';
import { Icon } from '@iconify/react';

export default function MedicationStep({ professionalName, patient, selectedCoverage, onValidationChange, isStepValid, medications, allProfileDataFilled, setMedications, prolongedTreatment, setProlongedTreatment, hidePatientData, setHidePatientData, diagnosisError, setDiagnosisError, handleNext, handleBack, handleGoToEditPatient: handleGoToEditPatient, monthDurationPrescription, setMonthDurationPrescription }: { professionalName: string, patient: PatientRecordDTO | null, selectedCoverage: HealthPatientCoverage | undefined, onValidationChange: (isValid: boolean) => void, isStepValid: boolean, allProfileDataFilled: boolean | string | undefined, medications: Medicine[] | null, setMedications: (meds: Medicine[]) => void, prolongedTreatment: boolean, setProlongedTreatment: (prolonged: boolean) => void, hidePatientData: boolean, setHidePatientData: (hiding: boolean) => void, diagnosisError: boolean, setDiagnosisError: (diagnosiserror: boolean) => void, handleNext: () => void, handleBack: () => void, handleGoToEditPatient: () => void, setActiveView: (av: any) => void, setSubActiveView: (av: any) => void, setPrevActiveView: (pav: any) => void, setPrevSubActiveView: (pav: any) => void, monthDurationPrescription: { months: number, description: string }, setMonthDurationPrescription: (mdp: { months: number, description: string }) => void }) {
    const [addMedicineModalVisible, setAddMedicineModalVisible] = useState(false);
    const [reuseMedicineModalVisible, setReuseMedicineModalVisible] = useState(false);
    const [validationAddMedicineModal, setValidationAddMedicineModal] = useState(true);
    const [validationReuseMedicineModal, setValidationReuseMedicineModal] = useState(false);
    const [drug, setDrug] = useState<MedicinalProductsAndSubstancesDTO | null>(null);
    const [presentation, setPresentation] = useState<MedicinalProductPresentationDTO | null>(null);
    const [lessThan400, setLessThan400] = useState(window.innerWidth <= 400);
    const [editing, setEditing] = useState(false);
    const [editingIndex, setEditingIndex] = useState<number | null>(null);
    const [indexToRemove, setIndexToRemove] = useState<number | null>(null);
    const [removeMedicineModal, setRemoveMedicineModal] = useState(false);

    const [loading, setLoading] = useState(false);
    const [isMobile, setisMobile] = useState(window.innerWidth < 700)
    const [paddingTop, setPaddingTop] = useState('55%');

    const [newMedication, setNewMedication] = useState<Medicine>(defaultMedicine);
    const [usedMedications, setUsedMedications] = useState<Medicine[]>([]);
    const [selectedMedications, setSelectedMedications] = useState<number[]>([]);

    useEffect(() => {
        const handleResize = () => {
            setisMobile(window.innerWidth < 700)
            setLessThan400(window.innerWidth <= 400);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const computePaddingTop = () => { //padding para las modales
            const minWidth = 430;
            const maxWidth = 1024;
            const minPadding = 20;
            const maxPadding = 50;
            const windowWidth = window.innerWidth;

            if (windowWidth <= minWidth) {
                setPaddingTop(`${maxPadding}%`);
            } else if (windowWidth >= maxWidth) {
                setPaddingTop(`${minPadding}%`);
            } else {
                const padding = maxPadding - ((windowWidth - minWidth) / (maxWidth - minWidth)) * (maxPadding - minPadding);
                setPaddingTop(`${padding}%`);
            }
        };

        computePaddingTop();
        window.addEventListener('resize', computePaddingTop);

        return () => {
            window.removeEventListener('resize', computePaddingTop);
        };
    }, []);

    useEffect(() => {
        const fetchMedications = async () => {
            try {
                setLoading(true)
                const medications = await getPreviousMedications(patient?.medereentity ?? -1, 2);
                setUsedMedications(medications);
            } catch (error) {
                console.error('Error fetching medications:', error);
            }
            finally {
                setLoading(false)
            }
        };

        fetchMedications();
    }, [patient?.id]);

    const handleAddMedication = () => {
        setAddMedicineModalVisible(true);
    };

    const handleSaveMedication = () => {
        if (editing) {
            const updatedMedications = medications?.map((med: Medicine, index) =>
                index === editingIndex ? newMedication : med
            );
            setMedications(updatedMedications ?? []);
            setEditing(false);
            setEditingIndex(null);
        } else {
            if (medications)
                console.log(newMedication)
            setMedications([...medications, newMedication]);
        }
        setAddMedicineModalVisible(false);
        setDrug(null)
        setPresentation(null)
        setNewMedication(defaultMedicine);
    };

    const handleAddMedicationFromHistory = () => {
        setReuseMedicineModalVisible(true);
    };

    const handleRemoveMedication = (index: number) => {
        const updatedMedications = medications?.filter((_, i) => i !== index);
        setMedications(updatedMedications ?? []);
        setRemoveMedicineModal(false)
    };

    const handleEditMedication = (index: number) => {
        if (medications) {
            const medicationToEdit: Medicine = medications[index];
            setNewMedication(medicationToEdit);
            setNewMedication(medicationToEdit); //sino no se setea
            setDrug({ description: medicationToEdit.issubstance ? medicationToEdit.drugdescription : medicationToEdit.medicinalproductdescription, substance: medicationToEdit.drug, drugdescription: medicationToEdit.drugdescription, externalidsubstance: medicationToEdit.externalidsubstance, issubstance: medicationToEdit.issubstance ?? false, medicinalproduct: medicationToEdit.medicinalproduct, medicinalproductdescription: medicationToEdit.medicinalproductdescription, externalidmedicinalproduct: medicationToEdit.externalidmedicinalproduct, medicinalproductpresentation: medicationToEdit.presentation, presentationdescription: medicationToEdit.presentationdescription, externalidpresentation: medicationToEdit.externalidpresentation, externalid: '', informationprovider: 0, price: 0, codebar: '', saleconditiondescription: '', salecondition: 0, descriptionfull: '', id: 0, drugmanufacturername: '' })
            setPresentation({ medicinalproductpresentation: medicationToEdit?.presentation, medicinalproductpresentationdesc: medicationToEdit?.presentationdescription, externalidpresentation: medicationToEdit.externalidpresentation, salecondition: medicationToEdit.salecondition, saleconditiondesc: medicationToEdit.saleconditiondescription })
            setEditing(true)
            setEditingIndex(index);
            setAddMedicineModalVisible(true);
        }
    };

    const handleReuseMedication = () => {
        const medicationsToAdd = usedMedications.filter((_, index) => selectedMedications.includes(index));
        if (medications)
            setMedications([...medications, ...medicationsToAdd]);
        setReuseMedicineModalVisible(false);
        setSelectedMedications([]);
    };

    useEffect(() => {
        if (medications)
            onValidationChange(medications.length > 0)
    }, [medications, onValidationChange]);

    useEffect(() => {
        if (!newMedication.drug && !newMedication.medicinalproduct) {
            setValidationAddMedicineModal(false)
            return
        }
        if (newMedication.issubstance && !newMedication.presentation) {
            setValidationAddMedicineModal(false)
            return
        }
        if (newMedication.quantity <= 0) {
            setValidationAddMedicineModal(false)
            return
        }
        if (newMedication.diagnosis?.trim() === "") {
            setValidationAddMedicineModal(false)
            return
        }
        setValidationAddMedicineModal(true)
    }, [newMedication]);

    useEffect(() => {
        if (selectedMedications.length === 0) {
            setValidationReuseMedicineModal(false)
            return
        }
        setValidationReuseMedicineModal(true)
    }, [selectedMedications]);

    useEffect(() => {
        if (!addMedicineModalVisible) {
            setNewMedication(defaultMedicine)
            setPresentation(null)
            setDrug(null)
            setEditing(false);
        }
    }, [addMedicineModalVisible]);

    useEffect(() => {
        if (!reuseMedicineModalVisible)
            setSelectedMedications([])
    }, [reuseMedicineModalVisible])

    useEffect(() => {
        const allMedicationsHaveDiagnosis = medications?.every(med => med.diagnosis && med.diagnosis.trim() !== '');
        if (allMedicationsHaveDiagnosis)
            setDiagnosisError(false)
    }, [medications])

    const renderWarningInsufficientData = () => {
        return diagnosisError && (
            <div className='warning-not-filled-data-meds' style={{ margin: isMobile ? '15px 0px' : '4px 10px' }}>
                <Icon icon="mdi:alert" style={{ margin: '0px 5px', color: '#FFC107', fontSize: '25px' }} />
                <p style={{ color: '#1E1E1E', fontSize: '13px', marginTop: '3px ' }}>Existen <label style={{ fontWeight: '700' }}>medicamentos</label> sin diagnóstico.</p>
            </div>
        )
    }

    const renderMedicationList = () => {
        const desktopStyle = { height: 'fit-content', maxHeight: '370px', overflow: 'auto', padding: '10px', borderRadius: '4px' }
        return <div className="medications-list">
            <h3><strong>Medicamentos agregados</strong></h3>
            {renderWarningInsufficientData()}
            {medications?.length === 0 ? (
                <label style={{ color: '#000000', fontSize: '14px', fontFamily: 'sans-serif', fontStyle: 'italic' }}>Todavía no hay medicamentos en la receta</label>
            ) : (
                <div style={isMobile ? null : desktopStyle}>
                    {medications?.map((med: Medicine, index) => (
                        <GeneralRecipeViewCard
                            key={index}
                            title={<strong>{(med.issubstance ? med.drugdescription : med.medicinalproductdescription) + " " + med.presentationdescription}</strong>}
                            detail={"Indicación: " + (med.indications ? med.indications : "-")}
                            detail2={"Diagnóstico: " + (med.diagnosis ? med.diagnosis : "-")}
                            detail3={"Cantidad: " + med.quantity}
                            onClick={() => { }}
                            backgroundColor="#E8EBEF"
                            border={(diagnosisError && (!med.diagnosis || med.diagnosis.trim() === '' || med.diagnosis.trim() === '-')) ? '1px solid #FFC107' : 'none'}
                            titleColor='#000000'
                            onEdit={() => handleEditMedication(index)}
                            onRemove={() => {
                                setIndexToRemove(index);
                                setRemoveMedicineModal(true);
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    }

    const loadMonthOptions = () => {
        return new Promise<{ months: number }[]>((resolve) => {
            const monthsOptions = Array.from({ length: 12 }, (_, i) => ({ months: i + 1, description: (i + 1) + (i + 1 == 1 ? ' mes' : ' meses') }));
            resolve(monthsOptions);
        });
    };

    if (isMobile)
        return (
            <div className="medication-step">
                <div className="patient-info">
                    <h2 style={{ marginTop: '10px' }}>Profesional: <strong>{professionalName}</strong></h2>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <h2>Paciente: <strong>{patient?.firstname + " " + patient?.lastname}</strong></h2>
                        <button onClick={handleGoToEditPatient}>
                            <i style={{ color: '#01717C', fontSize: '16px', padding: '8px', backgroundColor: '#EEEEEE', borderRadius: '100%' }} className="pi pi-pen-to-square"></i>
                        </button>
                    </div>
                    <div style={{ paddingTop: '4px', paddingLeft: '4px', boxShadow: '0 4px 4px rgba(0,0,0,0.15)' }}>
                        <CollapsibleCard
                            title={<label style={{ color: '#1E1E1E' }}>{selectedCoverage?.healthentityplan ? selectedCoverage?.healthentityplan?.healthentity?.commercialname : "PARTICULAR"}</label>}
                            noShadow
                        >
                            <div>
                                <p>Obra Social y Plan</p>
                                <p><strong>{selectedCoverage?.healthentityplan ? (selectedCoverage?.healthentityplan?.healthentity?.commercialname + " - " + selectedCoverage?.healthentityplan?.name) : "PARTICULAR - PARTICULAR"}</strong></p>
                                <p>Afiliado</p>
                                <p><strong>{selectedCoverage?.benefitnumber ? selectedCoverage?.benefitnumber : "-"}</strong></p>
                                <p style={{ fontFamily: 'sans-serif', fontStyle: 'italic', marginTop: '10px' }}>{!selectedCoverage || selectedCoverage?.voluntary ? "Cobertura Voluntaria" : "Cobertura Obligatoria"}</p>
                            </div>
                        </CollapsibleCard>
                    </div>
                    <GeneralRecipeViewCard
                        title={<label><strong>Ingresar</strong> un nuevo medicamento</label>}
                        onClick={handleAddMedication}
                        backgroundColor="#FFFFFF"
                        titleColor="#009688"
                        boxShadow='0 2px 5px rgba(0,0,0,0.2)'
                    />
                    {usedMedications.length > 0 && <GeneralRecipeViewCard
                        title={<label><strong>Reutilizar</strong> un medicamento</label>}
                        detail={<label>Existen <strong>{usedMedications.length + " items"}</strong> en el historial del paciente</label>}
                        detailFontSize='13px'
                        detailColor='#404040'
                        onClick={handleAddMedicationFromHistory}
                        backgroundColor="#FFFFFF"
                        titleColor="#009688"
                        boxShadow='0 2px 5px rgba(0,0,0,0.2)'
                    />}
                </div>
                <hr />
                {renderMedicationList()}
                <hr />
                <div className="general-diagnosis">
                    <div style={{ display: 'flex', flexDirection: 'column', marginTop: '15px' }}>
                        <label style={{ marginBottom: '8px' }}>
                            <CustomCheckBox
                                checked={prolongedTreatment}
                                onChange={(e) => e.target.checked ? setProlongedTreatment(e.target.checked) : null}
                            />
                            <span style={{ fontSize: '15px' }}>Tratamiento prolongado</span>
                        </label>
                        <label>
                            <CustomCheckBox
                                checked={hidePatientData}
                                onChange={(e) => e.target.checked ? setHidePatientData(e.target.checked) : null}
                            />
                            <span style={{ fontSize: '15px' }}>Ocultar datos del paciente</span>
                        </label>
                        <hr />
                        <div style={{ marginBottom: '35px', display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                            <h2>Repetir receta durante</h2>
                            <Combobox
                                className={`border2 w-28`}
                                getItems={loadMonthOptions}
                                optionLabel="description"
                                placeholder="Seleccionar"
                                value={monthDurationPrescription}
                                setValue={(e) => {
                                    setMonthDurationPrescription({ months: e.months, description: e.description });
                                }}
                            />
                        </div>
                    </div>
                </div>

                <Modal
                    visible={addMedicineModalVisible}
                    setVisible={setAddMedicineModalVisible}
                    header={editing ? <label><strong>Editar</strong> medicamento</label> : <label><strong>Ingresar</strong> un nuevo medicamento</label>}
                    headerStyle={{ fontSize: '12px' }}
                    className="h-full"
                >
                    <div className="medication-step">
                        <span>Marca comercial o droga</span>
                        <Combobox
                            className='border2 mb-4'
                            getItems={getMedicines}
                            params={{ InforProvider: 2, healthEntityId: selectedCoverage.healthentityplan?.healthentity?.healthentity ?? -1 }}
                            optionLabel='description'
                            value={drug}
                            setValue={(e: MedicinalProductsAndSubstancesDTO | null) => {
                                setDrug(e)
                                setNewMedication({
                                    ...newMedication,
                                    drug: e?.substance ?? 0,
                                    drugdescription: e?.drugdescription ?? '',
                                    externalidsubstance: e?.externalidsubstance ?? '',
                                    issubstance: e?.issubstance ?? false,
                                    duplicate: e?.salecondition === SaleCondition.ArchivedPrescription,
                                    presentation: e?.medicinalproductpresentation ?? 0, //si es droga, vienen nulos lo de presentacion y marca comercial, y los datos de la presentacion se cargan en el combo de abajo
                                    presentationdescription: e?.presentationdescription ?? '',
                                    externalidpresentation: e?.externalidpresentation ?? '',
                                    medicinalproduct: e?.medicinalproduct ?? 0,
                                    medicinalproductdescription: e?.medicinalproductdescription ?? '',
                                    externalidmedicinalproduct: e?.externalidmedicinalproduct ?? '',
                                    salecondition: e?.salecondition ?? 1,
                                    saleconditiondescription: e?.saleconditiondescription ?? 'probando',
                                })
                                setPresentation(null)
                            }}
                        />
                        {newMedication?.drug && newMedication.issubstance ? (<p>Presentaciones</p>) : null}
                        {newMedication?.drug && newMedication.issubstance ? (<Combobox
                            className='border2 mb-4'
                            getItems={getPresentations}
                            optionLabel='medicinalproductpresentationdesc'
                            params={{ informationProvider: 2, id: newMedication.drug, issubstance: newMedication.issubstance }}
                            value={presentation}
                            setValue={(e: MedicinalProductPresentationDTO | null) => {
                                setPresentation(e)
                                setNewMedication({
                                    ...newMedication,
                                    presentation: e?.medicinalproductpresentation ?? 0,
                                    presentationdescription: e?.medicinalproductpresentationdesc ?? '',
                                    externalidpresentation: e?.externalidpresentation ?? '',
                                    duplicate: e?.salecondition === SaleCondition.ArchivedPrescription,
                                    salecondition: e?.salecondition ?? 1,
                                    saleconditiondescription: e?.saleconditiondesc ?? 'probando',
                                })
                            }}
                            disable={!newMedication.drug}
                        />) : null}

                        <p>Cantidad</p>
                        <InputTextCustom
                            className='border2'
                            inputType={EInputTypes.NUMBER}
                            value={newMedication.quantity}
                            onChange={(e) => setNewMedication({ ...newMedication, quantity: e.target.value })}
                        />

                        <div className='mb-3'>
                            <label>
                                <CustomCheckBox
                                    checked={newMedication.duplicate}
                                    onChange={(e) => setNewMedication({ ...newMedication, duplicate: e.target.checked ?? false })}
                                />
                                <span style={{ fontSize: '14px', paddingTop: '15px' }}>Por duplicado</span>
                            </label>
                        </div>

                        <span>Diagnóstico</span>
                        <InputTextCustom
                            className='border2 mb-4'
                            value={newMedication.diagnosis}
                            onChange={(e) => setNewMedication({ ...newMedication, diagnosis: e.target.value })}
                        />

                        <span>Indicaciones (opcional)</span>
                        <InputTextCustom
                            className={`border2 mb-${lessThan400 ? '16' : '20'}`}
                            placeholder="Ingresar las indicaciones"
                            value={newMedication.indications}
                            onChange={(e) => setNewMedication({ ...newMedication, indications: e.target.value })}
                        />

                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '25px' }}>
                            <Button
                                label={editing ? "Guardar" : "Agregar a la receta"}
                                onClick={handleSaveMedication}
                                disabled={!validationAddMedicineModal}
                                style={{ marginBottom: '15px', backgroundColor: validationAddMedicineModal ? '#14C7BC' : '#9E9E9E', border: 'none', height: '36px' }}
                            />
                        </div>
                    </div>
                </Modal>

                <Modal
                    visible={reuseMedicineModalVisible}
                    setVisible={setReuseMedicineModalVisible}
                    header={<label><strong>Reutilizar</strong> un medicamento</label>}
                    headerStyle={{ fontSize: '12px' }}
                    className="h-full"
                >
                    <div className="modal-body">
                        {usedMedications && usedMedications.length > 0 ? (
                            <div>
                                <div style={{ height: 'calc(101vh - 295px)', overflowX: 'auto', overflowY: 'auto', paddingTop: '10px', borderRadius: '4px' }}>
                                    {usedMedications.map((med: Medicine, index) => (
                                        <GeneralRecipeViewCard
                                            key={index}
                                            title={<strong>{med.issubstance ? med.drugdescription : med.medicinalproductdescription + " " + med.presentationdescription}</strong>}
                                            detail={"Indicación: " + (med.indications ? med.indications : "-")}
                                            detail2={"Diagnóstico: " + (med.diagnosis ? med.diagnosis : "-")}
                                            detail3={"Cantidad: " + med.quantity}
                                            detail4={med.lastused}
                                            onClick={() => {
                                                if (selectedMedications.includes(index)) {
                                                    setSelectedMedications(selectedMedications.filter(i => i !== index));
                                                } else {
                                                    setSelectedMedications([...selectedMedications, index]);
                                                }
                                            }}
                                            backgroundColor="#E8EBEF"
                                            border="none"
                                            titleColor='#000000'
                                            showCheckbox
                                            isChecked={selectedMedications.includes(index)}
                                            onCheckboxChange={() => {
                                                if (selectedMedications.includes(index)) {
                                                    setSelectedMedications(selectedMedications.filter(i => i !== index));
                                                } else {
                                                    setSelectedMedications([...selectedMedications, index]);
                                                }
                                            }}
                                        />
                                    ))}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '15px' }}>
                                    <Button
                                        label="Agregar a la receta"
                                        onClick={handleReuseMedication}
                                        disabled={!validationReuseMedicineModal}
                                        style={{ marginBottom: '15px', backgroundColor: validationReuseMedicineModal ? '#14C7BC' : '#9E9E9E', border: 'none', height: '36px' }}
                                    />
                                    <Button
                                        label={"Cancelar"}
                                        onClick={() => setReuseMedicineModalVisible(false)}
                                        style={{ backgroundColor: '#FFFFFF', color: '#545454', height: '36px', border: '1px solid #3CB8BA' }}
                                    />
                                </div>
                            </div>
                        ) : <p style={{ color: '#000000', fontSize: '14px', fontFamily: 'sans-serif', fontStyle: 'italic' }}>No se han encontrado resultados</p>}
                    </div>
                </Modal>

                <WindowLoader showLoader={loading} className='whiteSpinner' />

                <Modal visible={removeMedicineModal} setVisible={setRemoveMedicineModal}
                    header={"Estás por eliminar el medicamento"}
                    headerStyle={{ fontSize: '12px', textAlign: 'center', paddingTop: paddingTop }}
                    className='h-full'
                    closable={false}>
                    <div style={{ marginTop: '1rem', textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
                        <Button
                            label="Si, eliminar"
                            onClick={() => handleRemoveMedication(indexToRemove ?? -1)}
                            style={{ marginBottom: '15px', backgroundColor: '#14C7BC', border: 'none', height: '36px' }}
                        />
                        <Button
                            label={"Cancelar"}
                            onClick={() => setRemoveMedicineModal(false)}
                            style={{ backgroundColor: '#FFFFFF', color: '#545454', height: '36px', border: '1px solid #3CB8BA' }}
                        />
                    </div>
                </Modal>
            </div>
        );
    else
        return (
            <div>
                <div>
                    <h2>Profesional: <strong>{professionalName}</strong></h2>
                    <h2 style={{ marginTop: '4px' }}>Paciente: <strong>{patient?.firstname + " " + patient?.lastname}</strong></h2>
                    <div style={{ marginBottom: '35px', display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                        <h2>Obra Social: <strong>{selectedCoverage?.healthentityplan?.healthentity?.commercialname ? (selectedCoverage?.healthentityplan?.healthentity?.commercialname + " - " + selectedCoverage?.healthentityplan?.name + " - " + selectedCoverage?.benefitnumber) : "PARTICULAR - PARTICULAR - -"}</strong></h2>
                        <button style={{}} onClick={handleGoToEditPatient}>
                            <i style={{ color: '#01717C', fontSize: '16px', padding: '8px', backgroundColor: '#EEEEEE', borderRadius: '100%' }} className="pi pi-pen-to-square"></i>
                        </button>
                    </div>
                </div>
                <div className="medication-step" style={{ display: 'flex', flexDirection: 'row', position: 'relative' }}>
                    <div style={{ flex: '1', maxWidth: '650px' }}>
                        <div className="patient-info">
                            <GeneralRecipeViewCard
                                title={<label><strong>Ingresar</strong> un nuevo medicamento</label>}
                                onClick={handleAddMedication}
                                backgroundColor="#FFFFFF"
                                titleColor="#009688"
                                boxShadow='0 2px 5px rgba(0,0,0,0.2)'
                            />
                            {usedMedications.length > 0 && <GeneralRecipeViewCard
                                title={<label><strong>Reutilizar</strong> un medicamento</label>}
                                detail={<label>Existen <strong>{usedMedications.length + " items"}</strong> en el historial del paciente</label>}
                                detailFontSize='13px'
                                detailColor='#404040'
                                onClick={handleAddMedicationFromHistory}
                                backgroundColor="#FFFFFF"
                                titleColor="#009688"
                                boxShadow='0 2px 5px rgba(0,0,0,0.2)'
                            />}
                        </div>
                        <hr />
                        <div className="general-diagnosis">
                            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '15px' }}>
                                <label style={{ marginBottom: '8px' }}>
                                    <CustomCheckBox
                                        checked={prolongedTreatment}
                                        onChange={(e) => setProlongedTreatment(e.target.checked ?? false)}
                                    />
                                    <span style={{ fontSize: '15px' }}>Tratamiento prolongado</span>
                                </label>
                                <label>
                                    <CustomCheckBox
                                        checked={hidePatientData}
                                        onChange={(e) => setHidePatientData(e.target.checked ?? false)}
                                    />
                                    <span style={{ fontSize: '15px' }}>Ocultar datos del paciente</span>
                                </label>
                                <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                                    <h2>Repetir receta durante</h2>
                                    <Combobox
                                        className={`border2 w-37`}
                                        getItems={loadMonthOptions}
                                        optionLabel="description"
                                        placeholder="Seleccionar"
                                        value={monthDurationPrescription}
                                        setValue={(e) => {
                                            setMonthDurationPrescription({ months: e.months, description: e.description });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="field" style={{ borderLeft: '4px solid rgba(28, 50, 79, 0.38)', paddingLeft: '1rem', marginLeft: '1rem', marginRight: '1rem', minWidth: '442px', display: 'flex', flexDirection: 'column', flex: '1' }}>
                        <div style={{ flex: '1' }}>
                            {renderMedicationList()}
                        </div>
                        <div style={{ padding: '15px', display: 'flex', flexDirection: 'column', marginTop: 'auto' }}>
                            <div style={{ display: 'flex', justifyContent: 'start', gap: '1rem' }}>
                                <Button
                                    className='btnRpContinue'
                                    label={"Continuar"}
                                    onClick={handleNext}
                                    disabled={!isStepValid || !allProfileDataFilled}
                                    style={{ width: '170px', backgroundColor: (isStepValid && allProfileDataFilled) ? '#14C7BC' : '#9E9E9E', border: 'none', height: '36px' }}
                                />
                                <Button
                                    className='btnRpBack'
                                    label={"Volver"}
                                    onClick={handleBack}
                                    style={{ width: '170px', backgroundColor: '#FFFFFF', color: '#545454', height: '36px', border: '1px solid #3CB8BA' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    visible={addMedicineModalVisible}
                    setVisible={setAddMedicineModalVisible}
                    header={editing ? <label><strong>Editar</strong> medicamento</label> : <label><strong>Ingresar</strong> un nuevo medicamento</label>}
                    headerStyle={{ fontSize: '12px' }}
                    className="h-full"
                >
                    <div className="medication-step" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <div style={{ flex: '1' }}>
                                <span>Marca comercial o droga</span>
                                <Combobox
                                    className='border2 mb-4'
                                    getItems={getMedicines}
                                    params={{ InforProvider: 2, healthEntityId: selectedCoverage.healthentityplan?.healthentity?.healthentity ?? -1 }}
                                    optionLabel='description'
                                    value={drug}
                                    setValue={(e: MedicinalProductsAndSubstancesDTO | null) => {
                                        setDrug(e);
                                        setNewMedication({
                                            ...newMedication,
                                            drug: e?.substance ?? 0,
                                            drugdescription: e?.drugdescription ?? '',
                                            externalidsubstance: e?.externalidsubstance ?? '',
                                            issubstance: e?.issubstance ?? false,
                                            presentation: e?.medicinalproductpresentation ?? 0,
                                            presentationdescription: e?.presentationdescription ?? '',
                                            externalidpresentation: e?.externalidpresentation ?? '',
                                            medicinalproduct: e?.medicinalproduct ?? 0,
                                            medicinalproductdescription: e?.medicinalproductdescription ?? '',
                                            externalidmedicinalproduct: e?.externalidmedicinalproduct ?? '',
                                            duplicate: e?.salecondition === SaleCondition.ArchivedPrescription,
                                            salecondition: e?.salecondition ?? 1,
                                            saleconditiondescription: e?.saleconditiondescription ?? 'probando',
                                        });
                                        setPresentation(null);
                                    }}
                                />
                            </div>
                            {newMedication?.drug && newMedication.issubstance ?
                                <div style={{ flex: '1' }}>
                                    <p>Presentaciones</p>
                                    <Combobox
                                        className='border2 mb-4'
                                        getItems={getPresentations}
                                        optionLabel='medicinalproductpresentationdesc'
                                        params={{ informationProvider: 2, id: newMedication.drug, issubstance: newMedication.issubstance }}
                                        value={presentation}
                                        setValue={(e: MedicinalProductPresentationDTO | null) => {

                                            setPresentation(e);
                                            setNewMedication({
                                                ...newMedication,
                                                presentation: e?.medicinalproductpresentation ?? 0,
                                                presentationdescription: e?.medicinalproductpresentationdesc ?? '',
                                                externalidpresentation: e?.externalidpresentation ?? '',
                                                duplicate: e?.salecondition === SaleCondition.ArchivedPrescription,
                                                salecondition: e?.salecondition ?? 1,
                                                saleconditiondescription: e?.saleconditiondesc ?? 'probando',
                                            });
                                        }}
                                        disable={!newMedication.drug}
                                    />
                                </div> : null}
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '-1rem' }}>
                            <div style={{ flex: '1' }}>
                                <span>Cantidad</span>
                                <InputTextCustom
                                    className='border2'
                                    inputType={EInputTypes.NUMBER}
                                    value={newMedication.quantity}
                                    onChange={(e) => setNewMedication({ ...newMedication, quantity: e.target.value })}
                                    style={{ maxWidth: '412px' }}
                                />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label>
                                    <CustomCheckBox
                                        checked={newMedication.duplicate}
                                        onChange={(e) => setNewMedication({ ...newMedication, duplicate: e.target.checked ?? false })}
                                    />
                                    <span style={{ fontSize: '14px', paddingTop: '15px' }}>Por duplicado</span>
                                </label>
                            </div>
                        </div>

                        <div style={{ marginTop: '1rem', marginBottom: '-1rem' }}>
                            <span>Diagnóstico</span>
                            <InputTextCustom
                                className='border2 mb-4'
                                value={newMedication.diagnosis}
                                onChange={(e) => setNewMedication({ ...newMedication, diagnosis: e.target.value })}
                            />
                        </div>

                        <div>
                            <span>Indicaciones (opcional)</span>
                            <InputTextCustom
                                className='border2'
                                placeholder="Ingresar las indicaciones"
                                value={newMedication.indications}
                                onChange={(e) => setNewMedication({ ...newMedication, indications: e.target.value })}
                            />
                        </div>

                        <div style={{ display: 'flex', gap: '10px', marginTop: 'auto' }}>
                            <Button
                                className='btnRpContinue'
                                label={editing ? "Guardar" : "Agregar a la receta"}
                                onClick={handleSaveMedication}
                                disabled={!validationAddMedicineModal}
                                style={{ backgroundColor: validationAddMedicineModal ? '#14C7BC' : '#9E9E9E', border: 'none', height: '36px', flex: '1' }}
                            />
                            <Button
                                className='btnRpBack'
                                label="Cancelar"
                                onClick={() => setAddMedicineModalVisible(false)}
                                style={{ backgroundColor: '#FFFFFF', color: '#545454', border: '1px solid #3CB8BA', height: '36px', flex: '1' }}
                            />
                        </div>
                    </div>
                </Modal>

                <Modal
                    visible={reuseMedicineModalVisible}
                    setVisible={setReuseMedicineModalVisible}
                    header={<label><strong>Reutilizar</strong> un medicamento</label>}
                    headerStyle={{ fontSize: '12px' }}
                    className="h-full"
                >
                    <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '20px', height: '100%' }}>
                        {usedMedications && usedMedications.length > 0 ? (
                            <div>
                                <div style={{ height: 'calc(101vh - 275px)', overflowX: 'auto', overflowY: 'auto', paddingTop: '10px', borderRadius: '4px' }}>
                                    {usedMedications.map((med: Medicine, index) => (
                                        <GeneralRecipeViewCard
                                            key={index}
                                            title={<strong>{med.issubstance ? med.drugdescription : med.medicinalproductdescription + " " + med.presentationdescription}</strong>}
                                            detail={"Indicación: " + (med.indications ? med.indications : "-")}
                                            detail2={"Diagnóstico: " + (med.diagnosis ? med.diagnosis : "-")}
                                            detail3={"Cantidad: " + med.quantity}
                                            detail4={med.lastused}
                                            onClick={() => {
                                                if (selectedMedications.includes(index)) {
                                                    setSelectedMedications(selectedMedications.filter(i => i !== index));
                                                } else {
                                                    setSelectedMedications([...selectedMedications, index]);
                                                }
                                            }}
                                            backgroundColor="#E8EBEF"
                                            border="none"
                                            titleColor='#000000'
                                            showCheckbox
                                            isChecked={selectedMedications.includes(index)}
                                            onCheckboxChange={() => {
                                                if (selectedMedications.includes(index)) {
                                                    setSelectedMedications(selectedMedications.filter(i => i !== index));
                                                } else {
                                                    setSelectedMedications([...selectedMedications, index]);
                                                }
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        ) : <p style={{ color: '#000000', fontSize: '14px', fontFamily: 'sans-serif', fontStyle: 'italic' }}>No se han encontrado resultados</p>}

                        {usedMedications && usedMedications.length > 0 ? (
                            <div style={{ display: 'flex', gap: '10px', marginTop: 'auto' }}>
                                <Button
                                    className='btnRpContinue'
                                    label="Agregar a la receta"
                                    onClick={handleReuseMedication}
                                    disabled={!validationReuseMedicineModal}
                                    style={{ backgroundColor: validationReuseMedicineModal ? '#14C7BC' : '#9E9E9E', border: 'none', height: '36px', flex: '1' }}
                                />
                                <Button
                                    className='btnRpBack'
                                    label={"Cancelar"}
                                    onClick={() => setReuseMedicineModalVisible(false)}
                                    style={{ backgroundColor: '#FFFFFF', color: '#545454', border: '1px solid #3CB8BA', height: '36px', flex: '1' }}
                                />
                            </div>
                        ) : null
                        }
                    </div>
                </Modal>

                <WindowLoader showLoader={loading} className='whiteSpinner' />

                <Modal
                    visible={removeMedicineModal}
                    setVisible={setRemoveMedicineModal}
                    header={"Estás por eliminar el medicamento"}
                    headerStyle={{ fontSize: '12px', textAlign: 'center' }}
                    width='w-medium'
                    closable={false}
                >
                    <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <Button
                            label="Sí, eliminar"
                            onClick={() => handleRemoveMedication(indexToRemove ?? -1)}
                            style={{ marginBottom: '15px', backgroundColor: '#14C7BC', border: 'none', height: '36px', width: '20rem' }}
                        />
                        <Button
                            label="Cancelar"
                            onClick={() => setRemoveMedicineModal(false)}
                            style={{ backgroundColor: '#FFFFFF', color: '#545454', height: '36px', border: '1px solid #3CB8BA', width: '20rem' }}
                        />
                    </div>
                </Modal>
            </div>
        );
}
